import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../css/NewsletterExamples.css';
import api from './api';

function NewsletterExamples({ onSelectNewsletter }) {
  const [newsletters, setNewsletters] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNewsletters();
  }, []);

  const fetchNewsletters = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await api.get(`${process.env.REACT_APP_API_URL}/get-newsletters`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      setNewsletters(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching newsletters:', error);
      setLoading(false);
    }
};

const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this newsletter?')) {
      try {
        const token = localStorage.getItem('token');
        await api.delete(`${process.env.REACT_APP_API_URL}/delete-newsletter/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        alert('Newsletter deleted successfully');
        fetchNewsletters(); // Refresh the list after deletion
      } catch (error) {
        console.error('Error deleting newsletter:', error);
        alert('Failed to delete newsletter.');
      }
    }
};



  return (
    <div className="newsletter-examples-container">
      <h2>Saved Newsletters</h2>
      {loading ? <p>Loading...</p> : (
        <div className="newsletter-grid">
          {newsletters.map((newsletter) => (
            <div className="newsletter-item" key={newsletter._id} onClick={() => onSelectNewsletter({ title: newsletter.title, content: newsletter.content })}>
              <h3>{newsletter.title}</h3>
              <p>{new Date(newsletter.dateSent).toLocaleDateString()}</p>
              <button className="delete-button" onClick={(e) => { e.stopPropagation(); handleDelete(newsletter._id); }}>
                Delete
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
  

}

export default NewsletterExamples;
